/* eslint-disable no-await-in-loop */
import { map, get, isEmpty, find, filter, forEach } from 'lodash'
import { WorkTicketsApi } from '@wiz-api/huizhou2-business'
import { StandardAlarmRecordApi } from '@wiz-api/personnel-position'

const workTicketsApi = new WorkTicketsApi()
const standardAlarmRecordApi = new StandardAlarmRecordApi()
/** ************************************************ 监控列表 **************************************** */
let markerList = []
let cameraList = []
let cloudRender
let drawHandler
let sceneId = ''
let isCustomEventName = ''
let AlarmTypeListMapLists = {} // 电子围栏和报警信息的映射关系表
let ticketsImgMaps = {
  'ELECTRICAL_FIRST': {
    'alarm': 'yjdqbj',
    'normal': 'yjdq',
  },
  'ELECTRICAL_SECOND': {
    'alarm': 'ejdqbj',
    'normal': 'ejdq',
  },
  'THERMAL_CONTROL': {
    'alarm': 'rkbj',
    'normal': 'rk',
  },
  'WIND_TURBINE': {
    'alarm': 'fjbj',
    'normal': 'fj',
  },
  'MECHANICAL': {
    'alarm': 'jxbj',
    'normal': 'jx',
  },
  'DONGHUO_LEVEL_ONE': {
    'alarm': 'dhbj1',
    'normal': 'dh1',
  },
  'DONGHUO_LEVEL_TWO': {
    'alarm': 'dhbj2',
    'normal': 'dh2',
  },
  'Limited_Space_One': {
    'alarm': 'yxkjbj1',
    'normal': 'yxkj1',
  },
    'Limited_Space_Two': {
    'alarm': 'yxkjbj2',
    'normal': 'yxkj2',
  },
  'High_Altitude_Operations': {
    'alarm': 'gkzybj',
    'normal': 'gkzy',
  },
  'Hoisting_One': {
    'alarm': 'dzbj1',
    'normal': 'dz1',
  },
  'Hoisting_Two': {
    'alarm': 'dzbj2',
    'normal': 'dz2',
  },
  'Hoisting_Three': {
    'alarm': 'dzbj3',
    'normal': 'dz3',
  },
}
// 初始化数据
const initAreaData = () => {
  markerList = []
  cameraList = []
  drawHandler = null
  sceneId = ''
  isCustomEventName = ''
}
// 获取报警列表映射列表
const getAlarmListMap = async (standardFenceIds) => {
  let params = {
    standardFenceIds,
    alarmType: ['Leave', 'Entry'],
    alarmRemoveType: 0,
  }
  const [err, res] = await standardAlarmRecordApi.getStandardAlarmRecordExistType({
    body: params,
  })
  if (!err) {
    forEach(res.items, (item) => {
      AlarmTypeListMapLists[item.standardFenceId] = {
        standardFenceName: item.standardFenceName,
        isAlarm: item.alarmTypes.length > 0
      }
    })
  }
}
// 获取监控列表
const getDataList = async () => {
  const params = {
    status: 'Executing',
    pageNo: 1,
    pageSize: 999,
  }
  const [err, res] = await workTicketsApi.getWorkticketByPage({
    body: params,
  })
  if (!err) {
    await getAlarmListMap(filter(map(res.items, 'standardFenceId'), (item) => item))
    return res.items
  }
  // return [
  //   { pr_DeviceCode: 'Rectangle108', name: '摄像头1', type: 'dhbj1' },
  //   { pr_DeviceCode: 'Box060', name: '摄像头2', type: 'dz1' },
  //   { pr_DeviceCode: 'Box058', name: '摄像头2', type: 'gkzy' },
  //   { pr_DeviceCode: 'Box093', name: '摄像头2', type: 'yxkj1' },
  // ]
}
const PROJECT_NAME = Wiz.globalSettings.globalConfig?.modelSetting?.folderName || 'SAAS'
// 创建监控标签
const create = async (player, propSceneId, propCloudRender, customEventName = 'openElectricalWorkVote') => {
  // 驾驶舱和可视化都调用了此方法，目前驾驶舱都可以自定义名称 isCustomEventName
  // 可视化自定义名称默认为 openElectricalWorkVote
  // 初始化数据
  initAreaData()
  cloudRender = propCloudRender
  sceneId = propSceneId
  isCustomEventName = customEventName

  // 监听标签点击事件
  cloudRender.Dispatch.on('Marker', markerClick)
  drawHandler = new Promise(async (resolve) => {
    cameraList = await getDataList()    
    const options = []
    for (let i = 0; i < cameraList.length; i += 1) {      
      const item = cameraList[i]      
      if (item.prDeviceCode) {
        const codeInfo = await player.Native.ModelTree.findItemByCode(item.prDeviceCode, 0)
        const imgUrl = ticketsImgMaps[item.prTicketType]
          ? `data://../apps/${PROJECT_NAME}/icon/alarm/${
              ticketsImgMaps[item.prTicketType][
                AlarmTypeListMapLists[item.standardFenceId]?.isAlarm ? 'alarm' : 'normal'
              ]
            }.png`
          : ''
        if (codeInfo && !isEmpty(codeInfo) && imgUrl) {
          const { aabb } = await player.Native.ModelTree.calcItemAabb(codeInfo.item)
          const pos = Aabb.faceCenter([aabb?.max, aabb?.min], 'Z')
          options.push({
            id: item.prDeviceCode,
            pos, // 定位点，世界坐标，三维向量，默认值为[0, 0, 0]
            visible: true, // 显示隐藏状态，boolean类型，默认值为true
            backgroundUrl: imgUrl,
            // backgroundUrl: `data://../apps/SAAS/icon/fence-bg.png`,
            imgSize: [32, 48], // 图片显示大小，二维向量，-1表示使用图片原始大小，如[32, -1]为宽度设置为32（拉伸或压缩），高度为图片高度，默认值为[-1, -1]，均使用图片尺寸
            nodeOffset: [-16, -48], // 相对定位点的偏移量，二维向量，默认值为[0, 0]，标记左上角与定位点重合
          })
        }
      }
    }
    const res = await cloudRender.Marker.createByPicture(options)
    markerList = res.data
    resolve()
  })
}
// 标签事件
const markerClick = (e) => {
  // 左键点击并且有id
  if (e.type === 1 && e.markerId) {
    const currentMarker = find(markerList, (item) => {
      return item === e.markerId
    })
    if (currentMarker) {
      const currentData = find(cameraList, ['prDeviceCode', currentMarker])
      // 移动位置
      cloudRender.Camera.moveCamera('Code', currentData.prDeviceCode)
      if (isCustomEventName === 'openElectricalWorkVote') {
        const openEvent = new CustomEvent('openComponent', {
          detail: {
            toCom: {
              code: 'ElectricalWorkVote',
              origin: 'tag',
              name: '电气第一种工作票',
              originTagName: 'RiskAssignment',
            },
            type: 'tags',
            props: {
              buildingId: currentData,
            },
          },
        })
        window.dispatchEvent(openEvent)
      } else {
        // 执行外部事件
        const filterEvent = new CustomEvent(isCustomEventName, {
          detail: currentData,
        })
        window.dispatchEvent(filterEvent)
      }
    }
  }
}
const destroy = async (player) => {
  if (!player.Native) {
    return
  }
  await drawHandler
  if (!get(cloudRender, 'Marker')) return
  cloudRender.Marker.destroyMarker(markerList)
  // 取消标签的事件监听
  cloudRender.Dispatch.off('Marker', markerClick)
}

const toggleDisplay = async (type) => {
  await drawHandler
  await cloudRender.Marker.updateByPicture(
    map(markerList, (item) => {
      return {
        id: item,
        visible: type,
      }
    })
  )
}

// 隐藏标签
const hidden = async () => {
  await toggleDisplay(false)
}

// 重新显示标签
const display = async () => {
  await toggleDisplay(true)
}
// 显示影藏部分标签
const hiddenMarkes = async (hiddenIdsList) => {
  let currentList = []
  markerList.forEach((item) => {
    currentList.push({
      visible: hiddenIdsList.includes(item) ? true : false,
      id: item,
    })
  })
  await cloudRender.Marker.updateByPicture(currentList)
}
export default { create, destroy, hidden, display, hiddenMarkes }
